const ZENDESK_SNIPPET_ID = 'ze-snippet'
const ZENDESK_SNIPPET_SRC = 'https://static.zdassets.com/ekr/snippet.js?key=4f780b5f-3f42-4161-a97a-b04133d3cbd5'
const ZENDESK_LOAD_TIMEOUT = 10000

let zendeskLoadPromise = null

// 轮询等待 Zendesk 全局方法挂到 window 上，避免 script.onload 已触发但 zE 还没就绪。
const waitForZendesk = () => new Promise((resolve, reject) => {
  const startTime = Date.now()

  const checkZendesk = () => {
    if (typeof window.zE === 'function') {
      resolve(true)
      return
    }

    if (Date.now() - startTime >= ZENDESK_LOAD_TIMEOUT) {
      reject(new Error('Zendesk snippet load timeout'))
      return
    }

    window.setTimeout(checkZendesk, 50)
  }

  checkZendesk()
})

// 只在页面中插入一次 Zendesk snippet；如果脚本标签已经存在则直接复用。
const appendZendeskSnippet = () => new Promise((resolve, reject) => {
  const existingScript = document.getElementById(ZENDESK_SNIPPET_ID)

  if (existingScript) {
    resolve(existingScript)
    return
  }

  const script = document.createElement('script')
  script.id = ZENDESK_SNIPPET_ID
  script.src = ZENDESK_SNIPPET_SRC
  script.async = true
  script.onload = () => resolve(script)
  script.onerror = () => reject(new Error('Zendesk snippet load failed'))
  document.head.appendChild(script)
})

// 对外统一的加载入口：
// 1. SSR 环境直接跳过
// 2. 已经可用则直接返回
// 3. 未加载时创建单例 Promise，避免并发场景重复插入 script
export const loadZendeskSnippet = async () => {
  if (typeof window === 'undefined') {
    return false
  }

  if (typeof window.zE === 'function') {
    return true
  }

  if (!zendeskLoadPromise) {
    zendeskLoadPromise = appendZendeskSnippet()
      .then(() => waitForZendesk())
      .catch((error) => {
        zendeskLoadPromise = null
        throw error
      })
  }

  return zendeskLoadPromise
}
